import { routerMiddleware } from 'connected-react-router';
import { createStore, applyMiddleware, compose } from 'redux';
import { history } from './history';
import rootReducer from './reducer';

const composeEnahancer =
  window['__REDUX_DEVTOOLS_EXTENSION_COMPOSE__'] || compose;
const routeMiddleware = routerMiddleware(history);

const middleware = [routeMiddleware];

const store = createStore(
  rootReducer(history),
  composeEnahancer(applyMiddleware(...middleware))
);

export default store;
